rdefine('app/formular/collections/FormCollection',['backbone','app/formular/models/FormModel'],function(Backbone,FormModel) {
    return Backbone.Ribs.Collection.extend({
        model:FormModel,
        comparator:function(model) {
            return model.get("order");
        },
        initialize:function() {
            this.sort();
            this.on("add reset remove",_.bind(this._calcorder,this));
        },
        _calcorder:function() {
            _.each(this.models,function(model,i){
                model.set("order",i);
            });
            this.sort();
        }
    });
});